import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";
import {
    resendAdminLoginOtpRequest,
    resendAdminLoginOtpRequestError,
    resendAdminLoginOtpRequestSuccess,
} from "../../slices/auth/ResendAdminLoginOtpSlice";

export const ResendAdminLoginOtpAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(resendAdminLoginOtpRequest());
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.resendAdminLoginOtp,
                data: data,
                headers: { "Content-Type": "application/json" },
            });
            return dispatch(resendAdminLoginOtpRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(resendAdminLoginOtpRequestError(_error));
        }
    };
};